import { Chain, $ } from "./zeus/index";
import { clearLocalStorage } from "kanopi-components/utils/browser";

export const apiSettings = {
  headers: {
    "Content-Type": "application/json",
  },
};

// Comment out lines below if you want additional debug information
// Same change is required under kanopi/server/kanopi/kanopi/schema.py
// const debugSchema = {
//   __debug: {
//     sql: {
//       rawSql: "",
//     },
//   },
// };

// Not having this go through a Proxy makes VSCode's TypeScript slow/overworked
// const api = Chain('/graphql/', apiSettings);

/**
 * Send more meaningful errors to Sentry.
 *
 * Zeus is actually pretty terrible. It has awful error messages, and they don't integrate with Sentry well at
 * all. This proxy sends errors with more context, and logs better messages to the console.
 * TODO remove bc its irrelevant
 */
const api = new Proxy(
  {},
  {
    get(_, prop) {
      return async (...args) => {
        const operationName = getGqlFunc(args[0]);
        console.debug(
          `Calling API.${prop} ${operationName} with settings: `,
          apiSettings
        );
        const chain = Chain(
          `/graphql/?operationName=${operationName}`,
          apiSettings
        )(prop);

        // Comment out lines below if you want additional debug information
        // Same change is required under kanopi/server/kanopi/kanopi/schema.py
        // if (globalThis.settings?.STAGE_TYPE === "local") {
        //   args[0] = { ...args[0], ...debugSchema };
        // }
        args[1] = { operationName: operationName, variables: args[1] };

        try {
          return await chain(...args);
        } catch (e) {
          const response = e.response;

          if (JSON.stringify(e).includes("401 Unauthorized")) {
            console.log("Received 401 Unauthorized response. Logging out user.");
            setBearer(null);
            clearLocalStorage();
            window.location.reload();
            return; // Exit early to prevent further error handling
          }

          let message = `Error during ${operationName}`;

          if (response && globalThis.settings?.STAGE_TYPE !== "production") {
            delete response.data.__debug;
            message += ` response=${JSON.stringify(response)}`;
          }

          if (e.errors) {
            const errors = e.errors.map((error) => error.message);
            message += ` errors=${JSON.stringify(errors)}`;
          }

          const error = new Error(message);
          error.response = response;
          throw error;
        }
      };
    },
  }
);

function getGqlFunc(query) {
  return Object.keys(query)[0] || "<unknown>";
}

export function setBearer(token) {
  if (token) {
    console.debug("Set bearer token: ", token);
    apiSettings.headers["Authorization"] = `Bearer ${token}`;
  } else {
    console.debug("Clearing bearer token");
    delete apiSettings.headers["Authorization"];
  }
}

export default api;
export { $ };
